import React from 'react'

function Error() {
  return (
    <>
      <div class="alert alert-danger text-center" role="alert">
        ERROR! PAGE NOT FOUND
      </div>
    </>
  )
}

export default Error